import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { API_URL, URL_IMAGE } from "../services/api/config";
import { api } from "../services/api/api.index";
import { Link, useLocation, useParams } from "react-router-dom";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaLongArrowAltRight } from "react-icons/fa";
import moment from "moment";
import OverlaySpinner from "../components/overlaySpinner/OverlaySpinner";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Slider from "react-slick";
import PanigationAntStyled from "../components/layout/PanigationAntStyled";
import NewSlider from "../components/slider/NewSlider";
import { Helmet } from "react-helmet";

const BlogLevel1Screen = () => {
  const [dataSource, setDataSource] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const abc = useLocation();
  const [filter, setFilter] = useState({
    page: 1,
    limit: 12,
  });
  const [extraDataNew, setExtraDataNew] = useState({
    currentPage: 0,
    perPage: 0,
    totalItems: 0,
    totalPages: 0,
  });

  const getDataBlogs = async () => {
    setLoading(true);
    try {
      let { data, metadata, extraData } = await api.get(
        `${API_URL}api/v1/blogs/external/${params?.id}%2F${params?.idlevel1}`,
        {
          ...filter,
          status: "ACTIVE",
          depth: 3,
        }
      );
      setExtraDataNew(extraData);
      setDataSource(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  const onChangePaging = (page, pageSize) => {
    setFilter({ ...filter, page: page });
  };
  useEffect(() => {
    getDataBlogs();
  }, [params, filter]);
  // useEffect(() => {
  //   if (state?.level === 0) {
  //     setParentState(state);
  //   }
  // }, [state]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blogs__bread" style={{ marginTop: "36px" }}>
      <OverlaySpinner open={loading} text={""} />

      <Helmet>
        <meta charSet="utf-8" />
        <title>{dataSource?.name}</title>
        <meta name="description" content={dataSource?.name} />
      </Helmet>
      <h4 className="breadcrumbCss">
        <Link to="/">Trang chủ</Link> / <Link to="/blogs">Blog</Link> /&nbsp;
        <Link to={`/blogs/${dataSource?.parent_info?.url_path}`}>
          {dataSource?.parent_info?.name}
        </Link>
        &nbsp; /&nbsp; {dataSource?.name}
      </h4>
      <div className="blogs__subBlock__image" style={{ marginTop: "16px" }}>
        <LazyLoadImage
          src={`${URL_IMAGE}` + dataSource?.image_url}
          href="block2"
        />
      </div>
      <div className="blogs__subBlock__content">
        <div className="blogs__subBlock__content__time">
          <FaRegCalendarAlt />
          &nbsp;
          {moment(dataSource?.created_at).format("HH:mm DD/MM/YYYY")}
        </div>
        <div
          className="blogs__subBlock__content__des"
          dangerouslySetInnerHTML={{
            __html: dataSource?.content,
          }}
        ></div>
        {dataSource?.images?.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "16px",
              width: "100%",
            }}
          >
            <NewSlider dataSource={dataSource} />
          </div>
        )}
        {dataSource?.sub_content && (
          <div
            className="blogs__subBlock__content__des"
            dangerouslySetInnerHTML={{
              __html: dataSource?.sub_content,
            }}
          ></div>
        )}
      </div>
      <div className="blogs__items">
        <>
          {dataSource?.children?.map((x, index) => (
            <Link
              to={`/blogs/${x.url_path}`}
              key={index}
              className="blogs__items__block"
              style={{ marginTop: "12px" }}
            >
              <div className="blogs__items__block__image">
                <LazyLoadImage
                  src={`${URL_IMAGE}` + x?.image_url}
                  href="block2"
                />
              </div>

              <div className="blogs__items__block__content">
                <div className="blogs__items__block__content__time">
                  <FaRegCalendarAlt />
                  &nbsp;{moment(x?.created_at).format("HH:mm DD/MM/YYYY")}
                </div>
                <div className="blogs__items__block__content__title">
                  {x?.name}
                </div>

                <div className="blogs__items__block__content__footer">
                  <FaLongArrowAltRight />
                  &nbsp;Đọc thêm
                </div>
              </div>
            </Link>
          ))}
          {extraDataNew?.totalPages > 1 && (
            <PanigationAntStyled
              style={{ padding: "0 0 24px 0" }}
              current={filter?.page}
              pageSize={filter?.limit}
              showSizeChanger={false}
              onChange={onChangePaging}
              showTotal={false}
              total={extraDataNew?.totalItems}
            />
          )}
        </>
      </div>
    </div>
  );
};

export default BlogLevel1Screen;
